// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"index_breadcrumb__1_ZZe","breadcrumbItem":"index_breadcrumbItem__1nqdO","link":"index_link__1Y6GC"};